/*
  Provides a hook for mutating settings.js, primarily for users of Halyard.

  e.g.,
  window.spinnakerSettings.defaultInstancePort = 8080;
*/



// WEBPACK FOOTER //
// ./settings-local.js